export default __webpack_public_path__ + "static/media/04_photo.49a88343.jpg";